import "./src/styles/font.css";
import { GatsbyBrowser } from "gatsby";
import { GlobalProvider } from "./GlobalProvider";

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = GlobalProvider;
export const disableCorePrefetching: GatsbyBrowser["disableCorePrefetching"] =
  () => process.env.GATSBY_ACTIVE_ENV === "production";
